const InfoContainer = (props) => {
    const data = props.data;
    let content = "ErrorPage";
    if(data && data.content){
        content = data.content;
    }
    return (
        <div dangerouslySetInnerHTML={{
            __html: content
        }}>
        </div>
    );
}

export default InfoContainer;